import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UseLicenseType_BillingAccountsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UseLicenseType_BillingAccountsQuery = { __typename?: 'Query', BillingAccounts: Array<{ __typename?: 'BillingAccount', id: string, subscriptions: Array<{ __typename?: 'BillingSubscription', id: string, plan: { __typename?: 'Plan', id: string, licenseType: Types.LicenseType } }> }> };


export const UseLicenseType_BillingAccountsDocument = gql`
    query useLicenseType_BillingAccounts {
  BillingAccounts(input: {}) {
    id
    subscriptions {
      id
      plan {
        id
        licenseType
      }
    }
  }
}
    `;

/**
 * __useUseLicenseType_BillingAccountsQuery__
 *
 * To run a query within a React component, call `useUseLicenseType_BillingAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseLicenseType_BillingAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseLicenseType_BillingAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseLicenseType_BillingAccountsQuery(baseOptions?: Apollo.QueryHookOptions<UseLicenseType_BillingAccountsQuery, UseLicenseType_BillingAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseLicenseType_BillingAccountsQuery, UseLicenseType_BillingAccountsQueryVariables>(UseLicenseType_BillingAccountsDocument, options);
      }
export function useUseLicenseType_BillingAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseLicenseType_BillingAccountsQuery, UseLicenseType_BillingAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseLicenseType_BillingAccountsQuery, UseLicenseType_BillingAccountsQueryVariables>(UseLicenseType_BillingAccountsDocument, options);
        }
export type UseLicenseType_BillingAccountsQueryHookResult = ReturnType<typeof useUseLicenseType_BillingAccountsQuery>;
export type UseLicenseType_BillingAccountsLazyQueryHookResult = ReturnType<typeof useUseLicenseType_BillingAccountsLazyQuery>;
export type UseLicenseType_BillingAccountsQueryResult = Apollo.QueryResult<UseLicenseType_BillingAccountsQuery, UseLicenseType_BillingAccountsQueryVariables>;